export const environment = {
  production: true,
  configFile: '/assets/config.json',
};
